import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Table, Button, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';
import PaginationControls from './PaginationControls';

const PAGE_SIZE = 20;

const TrainingParticipants = () => {
  const { id: trainingId } = useParams();
  const [training, setTraining] = useState(null); // State to hold training details
  const [participants, setParticipants] = useState([]);
  const [registeredUserIds, setRegisteredUserIds] = useState(new Set()); // Track registered user IDs
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [error, setError] = useState('');
  const [page, setPage] = useState(1);
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${API_BASE_URL}/trainings/get_training.php?id=${trainingId}`,{
        credentials: 'include'  // This ensures cookies (including session cookies) are sent
      })
    .then(response => {
        const contentType = response.headers.get('content-type');
    
        // Log the status and response text for debugging
        console.log('Response Status:', response.status);
        
        // Attempt to read the response as text first
        return response.text().then((text) => {
          console.log('Raw Response:', text); // Log the raw response text
          
          if (!response.ok) {
            // If response is not ok, throw an error with the response text
            throw new Error(`Failed with status ${response.status}: ${text}`);
          }
    
          // If response is JSON, parse it
          if (contentType && contentType.includes('application/json')) {
            return JSON.parse(text); // Parse JSON manually
          } else {
            // Return the raw text if it's not JSON
            return text;
          }
        });
      })
      .then(data => {
        //if (data.success) {
          setTraining(data); // Set training details in state
        //}
      })
      .catch(error => console.error('Error fetching training:', error));
  }, [trainingId]);

  const fetchParticipants = () => {
    fetch(`${API_BASE_URL}/trainings/get_training_participants.php?detail=1&id=${trainingId}`, {
      credentials: 'include'
    })
      .then(response => {
        const contentType = response.headers.get('content-type');
        // Log the status and response text for debugging
        console.log('Response Status:', response.status);

        // Attempt to read the response as text first
        return response.text().then(text => {
           console.log('Raw Response:', text); // Log the raw response text

           if (!response.ok) {
            // If response is not ok, throw an error with the response text
            throw new Error(`Failed with status ${response.status}: ${text}`);
          }
          // If response is JSON, parse it
          if (contentType && contentType.includes('application/json')) {
            return JSON.parse(text); // Parse JSON manually
          } else {
            // Return the raw text if it's not JSON
            return text;
          }
        });
      })
      .then(data => {
        // Ensure data is always an array
        const participantsData = Array.isArray(data) ? data : [];
        setParticipants(participantsData);
        const userIds = new Set(participantsData.map(p => p.user_id));
        setRegisteredUserIds(userIds);
      })
      .catch(error => {
        console.error('Error fetching participants:', error);
        setParticipants([]); // Ensure state remains array even on error
      });
  };


  /*
  useEffect(() => {
    fetch(`${API_BASE_URL}/trainings/get_training_participants.php?detail=1&id=${trainingId}`,{
        credentials: 'include'  // This ensures cookies (including session cookies) are sent
      })
    .then(response => {
        const contentType = response.headers.get('content-type');
    
        // Log the status and response text for debugging
        console.log('Response Status:', response.status);
        
        // Attempt to read the response as text first
        return response.text().then((text) => {
          console.log('Raw Response:', text); // Log the raw response text
          
          if (!response.ok) {
            // If response is not ok, throw an error with the response text
            throw new Error(`Failed with status ${response.status}: ${text}`);
          }
    
          // If response is JSON, parse it
          if (contentType && contentType.includes('application/json')) {
            return JSON.parse(text); // Parse JSON manually
          } else {
            // Return the raw text if it's not JSON
            return text;
          }
        });
      })
      .then(data => {
        // Ensure data is always an array
        const participantsData = Array.isArray(data) ? data : [];
        setParticipants(participantsData);
        const userIds = new Set(participantsData.map(p => p.user_id));
        setRegisteredUserIds(userIds);
      })
      .catch(error => {
        console.error('Error fetching participants:', error);
        setParticipants([]); // Ensure state remains array even on error
      });
  }, [trainingId]);
 */

  useEffect(() => {
    fetchParticipants();
  }, [trainingId]);

const updateStatus = (participantId, newStatus) => {
  let actionText = '';
  if (newStatus === 'deregistered') actionText = 'unregister this participant';
  else if (newStatus === 'approved') actionText = 'approve this participant';
  else if (newStatus === 'rejected') actionText = 'reject this participant';

  Swal.fire({
    title: 'Are you sure?',
    text: `You are about to ${actionText}.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, proceed'
  }).then((result) => {
    if (result.isConfirmed) {
      fetch(`${API_BASE_URL}/trainings/update_participant_status.php`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ participantId, newStatus }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            setParticipants(prev =>
              prev.map(p =>
                p.id === participantId ? { ...p, status: newStatus } : p
              )
            );
            Swal.fire('Success', `Status updated to "${newStatus}"`, 'success');
          } else {
            Swal.fire('Error', data.message || 'Failed to update status.', 'error');
          }
        })
        .catch(error => {
          console.error('Error updating status:', error);
          Swal.fire('Error', 'An error occurred while updating status.', 'error');
        });
    }
  });
};

 
  return (
    <div className='p-2'>
      <h2>Registered Participants</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {/* Display training information */}
      {training && (
        <div>
          <h4>Training Details</h4>
          <p><strong>Code:</strong> {training.code}<br/>
          <strong>Title:</strong> {training.title}<br/>
          <strong>Description:</strong> {training.description}</p>
          <p><strong>Date:</strong> {training.start_date} to {training.end_date}<br/>
          <strong>Location:</strong> {training.location}</p>
        </div>
      )}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Designation</th>
            <th>Department</th>
            <th>Company</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
        {participants.length > 0 ? (
          participants.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE).map((participant, index) => {
            const isRegistered = registeredUserIds.has(participant.id);
            return (
            <tr key={participant.id}>
              <td>{(page - 1) * PAGE_SIZE + index + 1}</td>
              <td>{participant.name}</td>
              <td>{participant.designation}</td>
              <td>{participant.department}</td>
              <td>{participant.company}</td>
              <td>{participant.status}</td>
              <td>
                {participant.status === 'assigned' || participant.status === 'approved' ? (
                  <Button variant="danger" size="sm" onClick={() => updateStatus(participant.id, 'deregistered')}>Unregister</Button>
                ) : participant.status === 'pending' ? (
                  <>
                    <Button variant="success" size="sm" className="me-2" onClick={() => updateStatus(participant.id, 'approved')}>Approve</Button>
                    <Button variant="warning" size="sm" onClick={() => updateStatus(participant.id, 'rejected')}>Reject</Button>
                  </>
                ) : (
                  '-'
                )}
              </td>
            </tr>
          )})
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No participants found for this training
                </td>
              </tr>
        )}
        </tbody>
      </Table>
      <PaginationControls page={page} totalPages={Math.max(1, Math.ceil(participants.length / PAGE_SIZE))} onPageChange={setPage} />
    </div>
  );
};

export default TrainingParticipants;
